// extracted by mini-css-extract-plugin
module.exports = {"textarea":"mainPage_textarea__1LaBc","input":"mainPage_input__3NX88","paperDiv":"mainPage_paperDiv__2WgTo","paper":"mainPage_paper__1MdbN"};